/*global chrome*/
import React from "react";
import { Link } from "react-router-dom";
import Slider from "react-slick";

class WhyLove extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      sliderStyles: { marginLeft: "0px", width: "100%" },
    };
    // this.sliderRef = React.createRef();
  }

  // componentDidMount() {
  //   // Adjust slider width
  //   this.adjustSliderWidth();
  //   window.addEventListener("resize", this.adjustSliderWidth);
  // }

  // componentWillUnmount() {
  //   window.removeEventListener("resize", this.adjustSliderWidth);
  // }

  // adjustSliderWidth = () => {
  //   const container = document.querySelector(".container");
  //   const outerDiv = document.querySelector(".outer-wrapper");
  //   const slickList = document.querySelector(".slick-list");

  //   if (container && outerDiv && slickList) {
  //     const leftWidth = container.getBoundingClientRect().left;
  //     const rightWidth = window.innerWidth - outerDiv.getBoundingClientRect().right;

  //     this.setState({
  //       sliderStyles: {
  //         marginLeft: `${leftWidth}px`,
  //         marginRight: `${rightWidth}px`,
  //         width: `calc(100vw - ${leftWidth}px - ${rightWidth}px)`,
  //       },
  //     });
  //   }
  // };

  render() {
    // const settings = {
    //   slidesToShow: 3.5,
    //   slidesToScroll: 1,
    //   autoplay: false,
    //   dots: true,
    //   arrows: true,
    //   infinite: false,
    //   adaptiveHeight: true, 
    //   responsive: [
    //     {
    //       breakpoint: 991,
    //       settings: {
    //         slidesToShow: 2.5,
    //       },
    //     },
    //     {
    //       breakpoint: 767,
    //       settings: {
    //         slidesToShow: 1.5,
    //       },
    //     },
    //     {
    //       breakpoint: 480,
    //       settings: {
    //         slidesToShow: 1,
    //       },
    //     },
    //   ],
    // };
    const customslider = {      
      dots: false,
      arrows: false,
      infinite: true,
      slidesToShow: 1,
      slidesToScroll: 1,
      autoplay: true,
      autoplaySpeed: 4000,
    };

    return (
      <>
      {/* <div className="outer-wrapper m-0">
        <div className="whyLove dark-blue-bg"> 
          <div className="la-student-section slider-dot-arrow green-dots">
            <div className="container">
              <div className="row">
                <div className="whyLove-header">
                  <div>
                    <h2 className="secondary-heading text-start text-white">
                      Why People Love Language Academy
                    </h2>
                    <p className="sub-title text-white">
                      We provide the top-rated PTE training to the candidates to
                      make their career journey smooth
                    </p>
                  </div>
                  <img
                    src="/images/web-new-images/emojis/smile-icon1.png"
                    alt="LA"
                  />
                </div>
              </div>
            </div>
            <div className="slider-wrapper">
              <div className="slider" ref={this.sliderRef} style={this.state.sliderStyles}>
                <Slider {...settings} className="student-review feature-cards">
                  <div className="gradient-box">
                    <div className="feature-card">
                      <div className="img-wrapper">
                        <img
                          src="/images/web-new-images/icons/feature-icon1.svg"
                          alt="Experienced Trainer"
                        />
                      </div>
                      <h3>Experienced Trainer</h3>
                      <p>We have Pearson certified faculty members...</p>
                    </div>
                  </div>
                  <div className="gradient-box">
                    <div className="feature-card">
                      <div className="img-wrapper">
                        <img
                          src="/images/web-new-images/icons/feature-icon2.svg"
                          alt="Highest Success Rate"
                        />
                      </div>
                      <h3>Highest Success Rate</h3>
                      <p>Students will get a sure-shot success with the high...</p>
                    </div>
                  </div>
                  <div className="gradient-box">
                    <div className="feature-card">
                      <div className="img-wrapper">
                        <img
                          src="/images/web-new-images/icons/feature-icon3.svg"
                          alt="Free Books"
                        />
                      </div>
                      <h3>Free Books</h3>
                      <p>
                        Our PTE / NAATI training institute provides free books...
                      </p>
                    </div>
                  </div>
                  <div className="gradient-box">
                    <div className="feature-card">
                      <div className="img-wrapper">
                        <img
                          src="/images/web-new-images/icons/feature-icon4.svg"
                          alt="Discussion Sessions"
                        />
                      </div>
                      <h3>Discussion Sessions</h3>
                      <p>During the discussion sessions, Our experienced team...</p>
                    </div>
                  </div>
                  <div className="gradient-box">
                    <div className="feature-card">
                      <div className="img-wrapper">
                        <img
                          src="/images/web-new-images/icons/feature-icon5.svg"
                          alt="Affordable Fees"
                        />
                      </div>
                      <h3>Affordable Fees</h3>
                      <p>We offer the best PTE and NAATI coaching classes...</p>
                    </div>
                  </div>
                  <div className="gradient-box">
                    <div className="feature-card">
                      <div className="img-wrapper">
                        <img
                          src="/images/web-new-images/icons/feature-icon3.svg"
                          alt="Real Time Test Environment"
                        />
                      </div>
                      <h3>Real Time Test Environment</h3>
                      <p>We provide several mock tests for reading, listening...</p>
                    </div>
                  </div>
                </Slider>
              </div>
            </div>
            <div className="text-center">
              <Link to="/auth/register">
                <button className="dark-border primary-btn">REGISTER NOW</button>
              </Link>
            </div>
          </div>
        </div>
      </div> */}
        <div className="exam-pattern-section pb-0">
            <div className="container">
            <div className="row">
                <h2 className="primary-heading text-center">
                Why People Love <br className="d-block" /> <span className="wpl-badge pte-naati-badge text-white">Language Academy</span>
                </h2>
                <p className="sub-heading text-center">
                We provide the top-rated PTE training to the candidates <br className="d-none d-lg-block" /> to make their career journey smooth
              </p>
                <div className="pattern-cards-outer">
                  <div className="exam-pattern-cards position-relative">                
                      <Slider {...customslider}>
                        <div>                     
                          <div className="exam-pattern-card">
                              <div className="img-wrapper">
                                <img
                                src="/images/web-new-images/icons/speaking-icon.svg"
                                alt="LA"
                                />
                              </div>
                              <h3 className="card-title">Experienced Trainer</h3>
                              <p>
                              We have Pearson certified faculty members...
                              </p>                      
                          </div>                    
                        </div>
                        <div>                      
                          <div className="exam-pattern-card">
                              <div className="img-wrapper">
                                <img
                                src="/images/web-new-images/icons/speaking-icon.svg"
                                alt="LA"
                                />
                              </div>
                              <h3 className="card-title">Highest Success Rate</h3>
                              <p>
                              Students will get a sure-shot success with the high...</p>                      
                          </div>                
                        </div>
                        <div>                    
                          <div className="exam-pattern-card">
                              <div className="img-wrapper">
                                <img
                                src="/images/web-new-images/icons/speaking-icon.svg"
                                alt="LA"
                                />
                              </div>
                              <h3 className="card-title">Free Books</h3>
                              <p>
                              Our PTE / NAATI training institute provides free books...</p>                      
                          </div>                       
                        </div>
                        <div>                     
                          <div className="exam-pattern-card">
                              <div className="img-wrapper">
                                <img
                                src="/images/web-new-images/icons/speaking-icon.svg"
                                alt="LA"
                                />
                              </div>
                              <h3 className="card-title">Latest Resources</h3>
                              <p>Making use of the latest technology, we provide...</p>                      
                          </div>       
                        </div>   
                        <div>                        
                          <div className="exam-pattern-card">
                              <div className="img-wrapper">
                                <img
                                src="/images/web-new-images/icons/speaking-icon.svg"
                                alt="LA"
                                />
                              </div>
                              <h3 className="card-title">Online Support</h3>
                              <p>Our experts are always there to help the students through...</p>                      
                          </div>                      
                        </div>    
                        <div>        
                          <div className="exam-pattern-card">
                              <div className="img-wrapper">
                                <img
                                src="/images/web-new-images/icons/speaking-icon.svg"
                                alt="LA"
                                />
                              </div>
                              <h3 className="card-title">3500 + Questions to Practice</h3>
                              <p>We give the students various exercises and practice</p>                      
                          </div>                      
                        </div>
                        <div>        
                          <div className="exam-pattern-card">
                              <div className="img-wrapper">
                                <img
                                src="/images/web-new-images/icons/speaking-icon.svg"
                                alt="LA"
                                />
                              </div>
                              <h3 className="card-title">Discussion Sessions</h3>
                              <p>During the discussion sessions, Our experienced team...</p>                      
                          </div>                      
                        </div>
                        <div>        
                          <div className="exam-pattern-card">
                              <div className="img-wrapper">
                                <img
                                src="/images/web-new-images/icons/speaking-icon.svg"
                                alt="LA"
                                />
                              </div>
                              <h3 className="card-title">Affordable Fees</h3>
                              <p>We offer the best PTE and NAATI coaching classNamees...</p>                      
                          </div>                      
                        </div>
                        <div>        
                          <div className="exam-pattern-card">
                              <div className="img-wrapper">
                                <img
                                src="/images/web-new-images/icons/speaking-icon.svg"
                                alt="LA"
                                />
                              </div>
                              <h3 className="card-title">Real Time Test Environment</h3>
                              <p>We provide several mock tests for reading, listening...</p>                      
                          </div>                      
                        </div>
                      </Slider>
                  </div>
                  <div className="text-center">
                      <Link to="/auth/register" className="dark-border primary-btn">
                        REGISTER NOW <img src="/images/web-new-images/right-arrow.svg" alt="Register Now" />
                      </Link>
                  </div>
                </div>
            </div>
            </div>
        </div>  
       </>
    );
  }
}

export default WhyLove;
